import { Injectable } from '@angular/core';
import * as mime from 'mime';
/**
 * This is a common service that is used to download media files. This component gets called from assessment tab and document tab
 */
@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  downloadFile(content, data){
    const linkSource = `data:${content.contentType};base64,${content.data}`;
       const extension = mime.getExtension(content.contentType)
       const downloadLink = document.createElement("a");
       const fileName = `${data.fname}_${data.lname}_${new Date().getTime()}.${extension}`;
       downloadLink.href = linkSource;
       downloadLink.download = fileName;
       downloadLink.click();
 }
}
